import React, {Component} from "react";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import {ActionCreator} from "../../../../../actions/actions";
import {connect} from "react-redux";
import {gamesStoreSelectors} from "../../../store/store";
import {GamesActionCreators} from "../../../actions/actionCreators";
import Paginator from "../../../../../utils/Paginator/Paginator.component";
import Drawer from "../../../../../utils/Drawer/Drawer.component";
import CreateBundle from "../CreateBundle/CreateBundle.component";
import {CreationModes} from "../../../reducers/creationMode.reducer";
import {GameNavigation} from "../GameNavigation/GameNavigation.component";
import {checkPermission} from "../../../../../utils/Authorization/authorization";
import {Dialog} from "../../../../../utils/Dialog/Dialog.component";

import "./GameBundles.component.scss";

export interface GameBundlesProps {
    creationMode: any;
    updateCreationMode: ActionCreator;
    getGameBundles: ActionCreator;
    getGames: ActionCreator;
    gameBundlesLoading: boolean;
    gameBundles: any[];
    gameBundlesCount: number;
    clearCreateBundle: ActionCreator;
    createBundle: ActionCreator;
    editBundle: ActionCreator;
    updateCreatingBundle: ActionCreator;
    deleteBundle: ActionCreator;
    subsidiaries: any;
    subsidiariesLoading: boolean;
    getSubsidiaries: ActionCreator;
}

export interface GameBundlesState {
    selectedStringSearch: string;
    currentPage: number;
    showDialog: boolean;
    bundleToDelete: any;
}

class GameBundles extends Component<GameBundlesProps, GameBundlesState> {
    constructor(props) {
        super(props);

        this.state = {
            selectedStringSearch: "",
            currentPage: 1,
            showDialog: false,
            bundleToDelete: null,
        };
    }

    componentDidMount() {
        this.getGameBundles();

        this.props.getSubsidiaries();
    }

    getGameBundles = () => {
        this.props.getGameBundles({
            page: this.state.currentPage,
            top: 10,
            search: this.state.selectedStringSearch
        });
    }

    selectStringSearch = e => {
        this.setState({
            selectedStringSearch: e.target.value,
            currentPage: 1
        }, this.getGameBundles);
    };

    pageChange = newPage => {
        this.setState({
            currentPage: newPage
        }, this.getGameBundles);
    };

    onClearFilters = () => {
        this.setState({
            selectedStringSearch: "",
            currentPage: 1
        });
    };

    onCreateSubmit = bundle => {
        this.props.createBundle(bundle, {
            page: this.state.currentPage,
            top: 10,
            search: this.state.selectedStringSearch
        });
    };

    onEditSubmit = bundle => {
        this.props.editBundle(bundle, {
            page: this.state.currentPage,
            top: 10,
            search: this.state.selectedStringSearch
        });
    };

    onDialogClose = () => {
        this.setState({
            showDialog: false,
            bundleToDelete: null
        });
    };

    onDeleteBundle = bundleToDelete => {
        this.setState({
            showDialog: true,
            bundleToDelete
        });
    };

    onDialogConfirm = () => {
        this.props.deleteBundle(this.state.bundleToDelete, {
            page: this.state.currentPage,
            top: 10,
            search: this.state.selectedStringSearch
        });

        this.setState({
            showDialog: false,
            bundleToDelete: null
        });
    };

    renderSubsidiaries(subsidiaries, alias) {
        return (
            <div className="subsidiaries-available">
                {subsidiaries &&
                    subsidiaries.map(subsidiaryId => {
                        const subsidiary = this.props.subsidiaries.find(
                            sub => sub.id == subsidiaryId
                        );
                        if (subsidiary) {
                            let show_alias = alias.find(a => a.subsidiary == subsidiaryId)
                            return (
                                <React.Fragment>
                                    {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                                    {show_alias && show_alias.value &&
                                        <span className={'bundle-alias'}>{show_alias.value}</span>}
                                </React.Fragment>
                            );
                        } else {
                            return null;
                        }
                    })}
            </div>
        );
    }

    renderConfigs() {
        if (this.props.gameBundlesLoading || this.props.subsidiariesLoading) {
            return (
                <div className="bundles-loading">
                    <Components.LoadingRipple
                        width={"100px"}
                        height={"100px"}
                    />
                </div>
            );
        }

        if (this.props.gameBundlesCount === 0) {
            return (
                <div className="col-12">
                    <div className="bundles-list-no-bundles">
                        No Bundles to display. Please select different values to
                        try again.
                    </div>
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="cards-container">
                        {this.props.gameBundles.map((bundle, key) => {
                            return (
                                <div key={key} className="col-12 bundle">
                                    <div>
                                        <div className="bundle-game-actions">
                                            <p className="bundle-title">
                                                {bundle.name}
                                                <span className="bundle-id">
                                                    ID {bundle.id}
                                                </span>
                                                {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) && checkPermission(
                                                    "edit_bundles"
                                                ) && (
                                                    <button
                                                        className="tooltip-icon"
                                                        onClick={() =>
                                                            this.editBundle(
                                                                bundle
                                                            )
                                                        }
                                                    >
                                                        <span className="tooltip-text">Edit</span>
                                                        <i className="icon-pencil-alt-light"></i>
                                                    </button>
                                                )}
                                                {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) && checkPermission(
                                                    "delete_bundles"
                                                ) && (
                                                    <button
                                                        className="tooltip-icon"
                                                        onClick={() =>
                                                            this.onDeleteBundle(
                                                                bundle.id
                                                            )
                                                        }
                                                    >
                                                        <span className="tooltip-text">Delete</span>
                                                        <i className="icon-trash-alt-light"></i>
                                                    </button>
                                                )}
                                            </p>
                                        </div>
                                        <div className="bundle-subtitle">
                                            {this.renderSubsidiaries(
                                                bundle.subsidiaries,
                                                bundle.alias
                                            )}
                                            <br/>
                                            {bundle.games.length} game(s) in
                                            total
                                        </div>
                                    </div>

                                    <div className={`bundle-games`}>
                                        {bundle.games.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).map((game, gameKey) => {
                                            return (
                                                <div
                                                    key={gameKey}
                                                    className="bundle-game"
                                                >
                                                    <div>
                                                        <div className="bundle-game-body">
                                                            <div
                                                                className="bundle-game-header"
                                                                style={{
                                                                    backgroundImage: `url("${window.location.protocol}//${window.location.hostname}${game.image}")`
                                                                }}
                                                            />
                                                            <div className="bundle-game-name">
                                                                <span
                                                                    className="bundle-game-id">ID {game.id}
                                                                </span>
                                                                <p>
                                                                    <span>{game.name}</span><br/>
                                                                    <span
                                                                        className="bundle-subtitle">{game.trademark && game.trademark.name}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="col-12 paginator-col">
                        <Paginator
                            currentPage={this.state.currentPage}
                            totalPages={
                                Math.floor(this.props.gameBundlesCount / 10) + 1
                            }
                            onPageChange={this.pageChange}
                        />
                    </div>
                    <Dialog
                        open={this.state.showDialog}
                        onConfirm={this.onDialogConfirm}
                        onClose={this.onDialogClose}
                    >
                        You are about to delete a Game Bundle. Are you sure?
                    </Dialog>
                </React.Fragment>
            );
        }
    }

    closeCreateConf = () => {
        this.props.clearCreateBundle();
    };

    createBundle = () => {
        this.props.clearCreateBundle();
        this.props.updateCreationMode(CreationModes.ADD_BUNDLE);
    };

    editBundle = bundle => {
        const altBundle = {
            id: bundle.id,
            name: bundle.name,
            games: bundle.games.map(game => {
                return game.id;
            }),
            subsidiary: bundle.subsidiary,
            alias: bundle.alias
        };
        this.props.clearCreateBundle();
        this.props.updateCreatingBundle(altBundle, true);
        this.props.updateCreationMode(CreationModes.EDIT_BUNDLE);
    };

    render() {
        return (
            <div id="GameBundles" className="content">
                <GameNavigation>
                    {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) &&
                        checkPermission("edit_bundles") && (
                            <div className="add-menu">
                                <a className="new-game red-btn" onClick={this.createBundle}>
                                    <span>New Bundle</span>
                                </a>
                            </div>
                        )}
                    </GameNavigation>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="hall-filters">
                                <div id="BundlesPageFiltersBox">
                                    <div className="row">
                                        <div className="adjustable-filters">
                                            <div className="game-filter">
                                                <label className="label">
                                                    Search
                                                </label>
                                                <input
                                                    className="input"
                                                    placeholder="Bundle name"
                                                    onChange={
                                                        this.selectStringSearch
                                                    }
                                                />
                                            </div>

                                            <div>
                                                <button
                                                    className="clear-filters-btn"
                                                    onClick={
                                                        this.onClearFilters
                                                    }
                                                >
                                                    Clear All Filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="configurations-list-card">
                            <div className="configurations">
                                <div className="row">
                                    {this.renderConfigs()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {(this.props.creationMode == CreationModes.ADD_BUNDLE ||
                        this.props.creationMode ==
                        CreationModes.EDIT_BUNDLE) && (
                        <Drawer
                            title={
                                this.props.creationMode ==
                                CreationModes.ADD_BUNDLE
                                    ? "New Bundle"
                                    : "Edit Bundle"
                            }
                            onClose={this.closeCreateConf}
                        >
                            <CreateBundle
                                editBundle={this.onEditSubmit}
                                createBundle={this.onCreateSubmit}
                                subsidiaries={this.props.subsidiaries}
                            />
                        </Drawer>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: gamesStoreSelectors.creationMode(state),
    gameBundles: gamesStoreSelectors.gameBundles(state),
    gameBundlesLoading: gamesStoreSelectors.gameBundlesLoading(state),
    gameBundlesCount: gamesStoreSelectors.gameBundlesCount(state),
    subsidiaries: gamesStoreSelectors.subsidiaries(state),
    subsidiariesLoading: gamesStoreSelectors.subsidiariesLoading(state)
});

const mapDispatchToProps = {
    updateCreationMode: GamesActionCreators.updateCreationMode,
    clearCreateBundle: GamesActionCreators.clearCreateBundle,
    getGameBundles: GamesActionCreators.getGameBundles,
    createBundle: GamesActionCreators.createBundle,
    editBundle: GamesActionCreators.editBundle,
    updateCreatingBundle: GamesActionCreators.updateCreatingBundle,
    deleteBundle: GamesActionCreators.deleteBundle,
    getSubsidiaries: GamesActionCreators.getSubsidiaries
};

export default connect(mapStateToProps, mapDispatchToProps)(GameBundles);
